import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React from "react";

interface IXSifterProcessInfoDialogProps {
    open: boolean;
    onClose: () => void;
}

const XSifterProcessInfoDialog: React.FC<IXSifterProcessInfoDialogProps> = (props: IXSifterProcessInfoDialogProps) => {
    return (
        <Dialog open={props.open} onClose={props.onClose} maxWidth="sm" fullWidth aria-labelledby="id-process-info-title">
            <DialogTitle id="id-process-info-title">How XSifter Works</DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>
                    XSifter helps you build a query that finds the posts you care about, and then fetches those posts into a DiscoverText archive.
                    The process has four stages.
                </Typography>
                <Box component="ol" sx={{ paddingLeft: "24px" }}>
                    <li>
                        <Typography gutterBottom>
                            <strong>Enter an initial query.</strong> Describe the posts you want in plain English, or build a query yourself using filters, groups, and Boolean operations.
                            Give your query a title, then get an estimate to see roughly how many posts match.
                        </Typography>
                    </li>
                    <li>
                        <Typography gutterBottom>
                            <strong>Sample and refine.</strong> Retrieve a small sample of matching posts and score each one as relevant or not relevant.
                            You can add notes about the kinds of posts you want to see more or less of, and XSifter will use your scores and notes to suggest improved versions of your query.
                        </Typography>
                    </li>
                    <li>
                        <Typography gutterBottom>
                            <strong>Iterate on the refinement loop.</strong> Pick a refined query, get a new estimate, and sample again.
                            Repeat as many times as you like until the results consistently match what you are looking for.
                        </Typography>
                    </li>
                    <li>
                        <Typography gutterBottom>
                            <strong>Submit to download your data.</strong> When you are happy with the query, submit it.
                            All matching posts are fetched into a DiscoverText archive. This uses credits based on the number of posts.
                        </Typography>
                    </li>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}

export default XSifterProcessInfoDialog;
